export const mtvConfig = {
  APIList: {
    loginImgCode: '/server/captcha/login/generate',
    resetpwdImgCode: '/server/captcha/forgotpwd/generate',
    sendMsg: '/server/sms/login/code',
    sendVoiceMsg: '/server/sms/login/voice',
    accountLogin: '/server/user/login/account',
    codeLogin: '/server/user/login/sms',
    QQLogin: '/server/sns/auth/show?source=qq',
    WXLogin: '/server/sns/auth/show?source=wx',
    validateAccount: '/server/account/validate',
    resetpwdSendMsg: '/server/account/send/forgotpwd/code',
    resetpwdValidate: '/server/account/forgotpwd/validate',
    resetPwd: '/server/account/forgotpwd/reset',
    logOut: '/server/user/logout'
  },
  urlList: {
    Login: {
      path: '/login',
      name: 'Login'
    },
    LoginCode: {
      path: '/logincode',
      name: 'LoginCode'
    },
    ResetGetAccount: {
      path: '/resetpwd1',
      name: 'ResetGetAccount'
    },
    ResetGetCode: {
      path: '/resetpwd2',
      name: 'ResetGetCode'
    },
    ResetSetPwd: {
      path: '/resetpwd3',
      name: 'ResetSetPwd'
    },
    ResetpwdSuccess: {
      path: '/resetpwd4',
      name: 'ResetpwdSuccess'
    },
    LoginSuccess: {
      path: '/loginsuccess',
      name: 'LoginSuccess'
    },
    LoginFail: {
      path: '/loginfail',
      name: 'LoginFail'
    }
  },
  errorData: {status: -200, message: '网络异常'},
  errCode: {
    success: {code: '200', msg: ''},
    code400: {code: '400', msg: '请求参数有误'},
    code401: {code: '401', msg: '帐号不存在'},
    code402: {code: '402', msg: '帐号或密码不正确'},
    code403: {code: '403', msg: '输入的帐号格式有误'},
    code406: {code: '406', msg: '操作太频繁，请稍候重试'},
    code407: {code: '407', msg: '密码格式不正确'},
    code408: {code: '408', msg: '请在60s后再次发送'},
    code409: {code: '409', msg: '今日短信发送已达上限'},
    code102: {code: '102', msg: '图形验证码不正确'},
    code103: {code: '103', msg: '验证码不正确'},
    code106: {code: '106', msg: '发送验证码失败'},
    code107: {code: '107', msg: '通知状态机失败'},
    code108: {code: '108', msg: '获取accesstoken失败'},
    code109: {code: '109', msg: '会话信息失效'},
    code500: {code: '500', msg: '服务端异常'}
  },
  mobileCodeState: {
    disable: 'disable',
    enable: 'enable',
    timeout: 'timeout'
  },
  mobileCodeTxt: {
    disable: '获取验证码',
    enable: '获取验证码',
    timeout: '重新获取'
  },
  submitBtnState: {
    disable: 'disable',
    enable: 'enable'
  },
  sendVoiceMsgBtnState: {
    disable: 'disable',
    enable: 'enable',
    timeout: 'timeout'
  },
  countryList: [
      {'name': '中国大陆', 'code': '86'},
      {'name': '香港', 'code': '852'},
      {'name': '台湾', 'code': '886'},
      {'name': ' 澳门', 'code': '853'},
      {'name': '韩国', 'code': '82'},
      {'name': '日本', 'code': '81'},
      {'name': '美国', 'code': '1'},
      {'name': '加拿大', 'code': '1'},
      {'name': '英国', 'code': '44'},
      {'name': '澳大利亚', 'code': '61'},
      {'name': '新加坡', 'code': '65'},
      {'name': '马来西亚', 'code': '60'},
      {'name': '印度', 'code': '91'},
      {'name': '泰国', 'code': '66'},
      {'name': '德国', 'code': '49'},
      {'name': '意大利', 'code': '39'},
      {'name': '法国', 'code': '33'},
      {'name': '俄罗斯', 'code': '7'}
  ],
  reg: {
    email: /^[\w.-]+@(?:[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*\.)+[A-Za-z]{2,6}$/,
    chinaPhone: /^1\d{10}$/,
    otherPhone: /^\d{6,15}$/,
    imgCode: /^[0-9a-zA-z]{4}$/,
    mobileCode: /^\d{6}$/,
    pwd: /(?![a-z]+$|[0-9]+$|_+$)^[a-zA-Z0-9_]{6,20}$/
  },
  inputType: {
    mobile: 'mobile',
    mobileOrEmail: 'mobileOrEmail'
  },
  mobilePlaceholder: {
    mobile: '手机号码',
    mobileOrEmail: '手机号/邮箱'
  },
  errorMsg: {
    format: {
      account: '帐号格式有误',
      mobile: '手机格式有误',
      imgCode: '图片验证码格式有误',
      mobileCode: '验证码格式有误',
      pwd: '密码格式有误',
      repwd: '密码输入不一致'
    },
    empty: {
      imgCode: '请输入图片验证码',
      account: '请输入帐号',
      mobile: '请输入手机号码',
      mobileCode: '请输入验证码',
      pwd: '请输入密码',
      newpwd: '请输入新密码'
    }
  },
  channelType: {
    bbs: 'bbs',
    home: 'home',
    account: 'account'
  }
}
const ERROR_DATA = mtvConfig.errorData
export const mtvServers = {
  /***
   * 发送请求
   * @param context
   * @param account
   * @param password
   * @returns {Promise}
   */
  appServices (context, url, data, headerData) {
    return new Promise((resolve, reject) => {
      context.$http.post(url, data, {headers: headerData}).then((res) => {
        if (res.status === 200) {
          resolve(res.data)
        } else {
          resolve(ERROR_DATA)
        }
      }, (res) => {
        resolve(ERROR_DATA)
      })
    })
  },
  appServicesGet (context, url, data, headerData) {
    return new Promise((resolve, reject) => {
      context.$http.get(url, data, {headers: headerData}).then((res) => {
        if (res.status === 200) {
          resolve(res.data)
        } else {
          resolve(ERROR_DATA)
        }
      }, (res) => {
        resolve(ERROR_DATA)
      })
    })
  },
  isMobile () {
    let useragent = navigator.userAgent
    let isIpad = useragent.indexOf('iPad') > -1
    let ismobile = (!!useragent.match(/AppleWebKit.*Mobile.*/)) && !isIpad
    return ismobile
  },
  getChannelType (callback) {
    if (!callback) callback = ''
    if (callback.indexOf('bbs') > -1) {
      return mtvConfig.channelType.bbs
    } else if (callback.indexOf('moretv') > -1) {
      return mtvConfig.channelType.home
    } else {
      return mtvConfig.channelType.account
    }
  }

}



// WEBPACK FOOTER //
// ./src/services/services.js